import {FormControl, MenuItem, Select, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import {RequestScheduleSchema} from '../RequestScheduleLayout/validation/schemas/RequestScheduleSchema';
import {TypeOfConsultationEnum} from '../RequestScheduleLayout/constants';

const {label} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule.typeOfConsultation;

export const TypeOfConsultation = () => {
	const {setValue, watch} = useFormContext<RequestScheduleSchema>();
	const typeOfConsultationWatched = watch('typeOfConsultation');

	return (
		<Stack gap={2}>
			<Typography variant="subtitle2" color="text.secondary">
				{label}
			</Typography>
			<FormControl fullWidth>
				<Select
					value={typeOfConsultationWatched}
					onChange={e => setValue('typeOfConsultation', e.target.value)}>
					<MenuItem value={TypeOfConsultationEnum.TELE_OR_IN_PERSON}>
						{TypeOfConsultationEnum.TELE_OR_IN_PERSON}
					</MenuItem>
					<MenuItem value={TypeOfConsultationEnum.ONLY_IN_PERSON}>
						{TypeOfConsultationEnum.ONLY_IN_PERSON}
					</MenuItem>
				</Select>
			</FormControl>
		</Stack>
	);
};
